import { Transform } from "class-transformer";
import {
  IsBoolean,
  IsDate,
  IsEnum,
  IsNumber,
  IsOptional,
  IsString,
  Length,
  Min,
} from "class-validator";
import {
  type DeepPartial,
  OrganizationEventTicketCategory,
  OrganizationEventTicketType,
} from "../../../../types";
import type { CreateOrganizationEventTicketInput } from "./create-organization-event-ticket.dto";

export class UpdateOrganizationEventTicketDto
  implements DeepPartial<CreateOrganizationEventTicketInput>
{
  @IsString()
  @IsOptional()
  id?: string;

  @IsString()
  @Length(1, 128)
  @IsOptional()
  name?: string;

  @IsString()
  @Length(0, 1024)
  @IsOptional()
  description?: string;

  @Transform(({ value }) => Number(value))
  @IsNumber()
  @Min(0)
  @IsOptional()
  price?: number;

  @Transform(({ value }) => Number(value))
  @IsNumber()
  @Min(0)
  @IsOptional()
  quantity?: number;

  @IsEnum(OrganizationEventTicketType)
  @IsOptional()
  type?: OrganizationEventTicketType;

  @IsEnum(OrganizationEventTicketCategory)
  @IsOptional()
  category?: OrganizationEventTicketCategory;

  @IsBoolean()
  @IsOptional()
  isVisible?: boolean;

  @IsBoolean()
  @IsOptional()
  isFeesIncluded?: boolean;

  @IsOptional()
  @Transform(({ value }) => (value instanceof Date ? value : new Date(value)))
  @IsDate()
  startAt?: Date;

  @IsOptional()
  @Transform(({ value }) => (value instanceof Date ? value : new Date(value)))
  @IsDate()
  endAt?: Date;
}
